<template>
    <router-view/>
</template>
<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue